module.exports = __webpack_public_path__ + "static/media/21ECLAC30.bd755ea2.jpg";